import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BadgeModule } from 'primeng/badge';
import { OverlayBadgeModule } from 'primeng/overlaybadge';

type SeverityType =
  | 'success'
  | 'info'
  | 'warn'
  | 'danger'
  | 'secondary'
  | 'contrast';

@Component({
  selector: 'app-overlay-badge',
  standalone: true,
  imports: [CommonModule, BadgeModule, OverlayBadgeModule],
  templateUrl: './overlay-badge.component.html',
  styleUrls: ['./overlay-badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OverlayBadgeComponent {
  value = input<number | string>();
  severity = input<SeverityType>();
  badgeSize = input<'small' | 'large' | 'xlarge'>();
}
